<h2 [innerHTML]="title" [attr.icon]="icon" [id]="id"></h2>